<template>
    
    <b-row>
        
        <b-col cols="4" v-if='file'>
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }} المتضمن الموافقة على إحداث الفرع
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:file  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col> 
        <b-col md="4" cols="12" v-else>
            <info-card
            label="رقم محضر الجلسة الإدارية المتضمن الموافقة عللا إحداث الفرع"
            :value="data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="محافظة الفرع"
            :value="data.governorate_id ? data.governorate_id.name_ar :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="المنطقة"
            :value="data.sub_district_id ? data.sub_district_id.name_ar :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="العنوان التفصيلي"
            :value="data.address"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card label="رقم العقار"
            :value="data.real_estate_id ? data.real_estate_id.number :''"
            />
        </b-col>     
        <b-col md="4" cols="12">
            <info-card 
            label="الخدمات المقدمة"
            :value="data.services"
            />
        </b-col>
        <b-col cols="12" class="my-2">
            <h5>
                اللجنة الإدارية :
            </h5>
        </b-col>
        <b-col md="12" cols="12">
            <div>
                <b-tabs content-class="mt-3">
                    <b-tab v-for="(member , i) in data.administrativeCommittee" :key="i" :title="`العضو ${ getArrangement(i+1) }`">
                        <b-row>
                            <b-col md="4" cols="12">
                                <info-card
                                label="الاسم الكامل للعضو"
                                :value="member.employee_id ? member.employee_id.employee_or_volunteer_label :''"
                                />
                            </b-col>
                                
                            <b-col cols="4">
                                <div class="info-card px-2 py-1 my-1">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div>
                                       نشرة استعلامه
                                    </div>
                                    <div>
                                    <b-button
                                        variant="flat-info"
                                        v-b-toggle.doc-view
                                        class="btn-icon mx-25"
                                        v-b-tooltip.hover.v-info.bottom
                                        title="عرض المستند المرفوع"
                                        :to="{ name: 'file-view', query: { ep:member.security_dossier } }"
                                    >
                                        <feather-icon icon="EyeIcon"
                                    /></b-button>
                                    </div>
                                </div>
                                <div>
                                    <hr />
                                </div>
                                </div>
                            </b-col> 
                        </b-row>
                    </b-tab>
                </b-tabs>
            </div>
        </b-col>     
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton , BTabs , BTab } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import axios from "@axios";
import { arrangement } from "@/utils/utils";
import router from "@/router";


  export default {
    data() {
        return {
            file: '',
        }
    },
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton , BTabs , BTab
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },

    methods: {
    getArrangement(num){
      return arrangement(num)
    },
   
    },
    
    watch: {
        data: {
        handler: async function(newVal, oldVal) {
            
            const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                console.log("currentRoute" , currentRoute)
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }
        },
        deep: true
        }
    },
  };
  </script>